import { KatAppLayout, KatButton, KatPopover } from '@amzn/katal-react';
import React, { useState } from 'react';
import { useUser } from 'src/utils/UserContext';
import { Outlet } from 'react-router-dom';
import { memo } from 'react';

/**
 * AFTXApp - Simplified layout for AFTX (Amazon Fulfillment Technologies eXternalization) customers
 * 
 * AFTX users access Newton through FC Menu (tool code 2337) and are authenticated via AFTX cookies.
 * They only have access to the CORA (CPT Risk Management) functionality.
 * 
 * Key differences from regular App:
 * - No navigation tabs (Home, SLA, Bulk SLA, TRB Thresholds, etc.)
 * - Only CORA routes are available
 * - Authentication via FC Menu cookies instead of Midway
 */
const AFTXApp = memo(() => {
    const { user } = useUser();
    const [isHelpOpen, setIsHelpOpen] = useState(false);

    const permissionsAvailable = () => {
        return <ul style={{ listStyle: 'none', padding: 0 }}>
            {user?.isAuthorizedForSLAOverrides && (
                <li style={{ marginBottom: '0.5rem' }}>
                    SLA Override Access
                </li>
            )}
            {user?.isDevAdmin && (
                <li style={{ marginBottom: '0.5rem' }}>
                    Developer Access
                </li>
            )}
        </ul>;
    };

    return (
        <KatAppLayout>
            <div className={'navigationHeader'}>
                {/* No navigation tabs for AFTX customers - they only see CORA */}
                <div className={'profile-button'}>
                    <KatPopover katAriaBehavior='tooltip'
                                position='bottom'
                                triggerType='click'>
                        <KatButton
                            slot='trigger'
                            variant='secondary'>
                            Welcome {user?.login}
                        </KatButton>
                        <h4>Permissions Granted:</h4>
                        {permissionsAvailable()}
                        <h4>Support Resources</h4>
                        <ul>
                            <li>
                                <KatButton variant='link' onClick={() => window.open('/support/new')}>
                                    Create New Ticket
                                </KatButton>
                            </li>
                            <li>
                                <KatButton variant='link' onClick={() => window.open('/support/knowledge-base')}>
                                    Knowledge Base
                                </KatButton>
                            </li>
                        </ul>
                    </KatPopover>
                </div>
            </div>
            <div className={'main-content'}>
                <Outlet />
            </div>

            <footer slot='bottom'></footer>
        </KatAppLayout>
    );
});

export default AFTXApp;
